module.exports = __webpack_public_path__ + "img/Knudsen_Laerer_og_spraakmann.e829f238.jpg";